import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { HttpError } from 'ish-core/models/http-error/http-error.model';

@Component({
  selector: 'ish-shopping-basket-empty',
  templateUrl: './shopping-basket-empty.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ShoppingBasketEmptyComponent {
  readonly error = input<HttpError>(undefined);
}
